module.exports = __webpack_public_path__ + "media/images/countryrect/nz-e8481b480ab60ed029be1eb839d59491.svg";